import { styled, Tab, TabProps, Tabs, TabsProps } from "@mui/material";
import { hasNotProp } from "@sinch/utils/object";

export const LanguageTabs = styled(Tabs, { shouldForwardProp: hasNotProp(["focused", "error", "disabled"]) })<
  TabsProps & { focused?: boolean; error?: boolean; disabled?: boolean }
>(({ theme, focused, error, disabled }) => {
  const borderColor = error && !disabled ? theme.palette.error.main : theme.palette.grey[400];
  return {
    marginLeft: `${theme.shape.borderRadius}px`,
    marginRight: `${theme.shape.borderRadius}px`,
    marginTop: "-1px",
    minHeight: "auto",

    borderBottomLeftRadius: `${theme.shape.borderRadius}px !important`,
    borderBottomRightRadius: `${theme.shape.borderRadius}px !important`,
    width: "min-content",

    ...(focused
      ? {
          boxShadow: `0px 0px 0px 4px ${theme.palette.custom.blue[100]}`,
        }
      : {}),
    "& .MuiTab-root": {
      "&:first-of-type": {
        borderBottomLeftRadius: `${theme.shape.borderRadius}px !important`,
      },
      backgroundColor: theme.palette.grey["100"],
      minHeight: "16px",
      minWidth: "30px",
      padding: "4px 8px",
      borderBottom: `1px solid ${borderColor}`,
      borderLeft: `1px solid  ${borderColor}`,
      borderTop: `1px solid  ${borderColor}`,
      "&:last-of-type": {
        borderBottomRightRadius: `${theme.shape.borderRadius}px !important`,
        borderRight: `1px solid ${borderColor}`,
      },
      "&.Mui-selected": {
        borderTop: `1px solid ${theme.palette.background.paper}`,
        backgroundColor: theme.palette.background.paper,
      },
    },
  };
});

export const LanguageTab = styled(Tab, { shouldForwardProp: hasNotProp(["isEmpty"]) })<
  TabProps & { isEmpty?: boolean }
>(({ theme, isEmpty }) => ({
  color: isEmpty ? theme.palette.warning.main : undefined,
}));
